<template>
  <transition name="tabbar-leave">
    <div v-if="showTabbar" :class="['v-tabbar', { '--builder': isInBuilder }]">
      <tabbar-content :vertical="isDesktop" :show-pages="isDesktop" />

      <v-made-with-movement v-if="isDesktop" />
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import isBuilderContext from "@/lib/is-platform/is-builder-context"

import TabbarContent from "@/components/TabbarContent"
import { HIDDEN_ELEMENTS } from "@/lib/constants"

const MESSAGES_PATH = "/me/messages"

export default {
  components: {
    TabbarContent
  },

  computed: {
    ...mapState(["global"]),
    ...mapState("responsive", ["isDesktop"]),
    ...mapState("videos", { isVideoFullscreen: "isFullscreen" }),
    ...mapState("ui", ["isViewSwitcherShown"]),

    ...mapGetters("tabbar", ["isTabbarShown", "tabbarLinks"]),
    ...mapGetters("auth", ["isAuthenticated", "currentUser"]),
    ...mapGetters("ui", ["isElementHidden"]),

    showTabbar() {
      if (this.isElementHidden(HIDDEN_ELEMENTS.TABBAR) || this.hideInPath) {
        return false
      }

      if (this.isViewSwitcherShown && !this.isDesktop) {
        return false
      }

      if (this.forceShow) {
        return true
      }

      return this.isTabbarShown
    },

    forceShow() {
      return this.$route.path.startsWith("/me/") && !this.hideInPath
    },

    hideInPath() {
      return this.isDesktop
        ? false
        : this.$route.path.startsWith(MESSAGES_PATH + "/")
    },

    isInBuilder() {
      return isBuilderContext()
    }
  },

  methods: {
    isActive(link) {
      return link.path === "/"
        ? this.$route.path === "/"
        : this.$route.path.startsWith(link.path)
    },

    isMessageTabbar(link) {
      return link.path === MESSAGES_PATH
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.v-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: $tabbar--height;
  background: $color-ui--white;
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: $box-shadow--medium;
  z-index: $toolbar--z-index;

  @include tabbar-background;
}

@media screen and (min-width: $breakpoint--xl) {
  .v-tabbar:not(.--builder) {
    position: fixed;
    box-shadow: none;
    left: 0%;
    top: 0;
    height: 100%;
    max-height: 100vh;
    width: $tabbar--desktop-width;
    z-index: 100;
    border-right: 1px solid $color-ui--grey-20;
  }
}
</style>
